import { Send } from "lucide-react";
import { TELEGRAM_URL } from "@/lib/socialLinks";
import { useLocation } from "react-router-dom";

// Floating Telegram CTA — bottom-left on landing only.
// Hidden on app pages (/trade, /history, /partner) so it doesn't collide with
// the Emergent badge in the bottom-right or the live-trade ribbon on mobile.
// Closeable persistently via localStorage.
import { useState, useEffect } from "react";

const APP_PATHS = ["/trade", "/history", "/partner", "/auth/callback"];

const TelegramFloat = () => {
  const location = useLocation();
  const [closed, setClosed] = useState(true);
  useEffect(() => {
    setClosed(localStorage.getItem("vts_tg_float_hidden") === "1");
  }, []);
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem("vts_tg_float_hidden", "1");
    setClosed(true);
  };
  // Hide on app pages — they already have their own chrome (bottom nav,
  // active-trade ribbon, Emergent badge).
  const onAppPage = APP_PATHS.some((p) => location.pathname.startsWith(p));
  if (closed || onAppPage) return null;

  return (
    <a
      data-testid="telegram-float-cta"
      href={TELEGRAM_URL}
      target="_blank"
      rel="noreferrer noopener"
      className="fixed bottom-5 left-5 z-50 group flex items-center gap-2 bg-[#229ED9] hover:bg-[#1d8ec5] text-white pl-4 pr-3 py-3 rounded-full shadow-2xl shadow-[#229ED9]/30 transition-all hover:scale-105"
    >
      <Send className="h-4 w-4" />
      <span className="text-xs font-semibold font-body whitespace-nowrap">
        Join VTS Telegram
      </span>
      <button
        type="button"
        onClick={handleClose}
        aria-label="Hide"
        className="ml-1 -mr-1 h-5 w-5 rounded-full bg-white/15 hover:bg-white/30 text-white text-[10px] flex items-center justify-center transition"
      >
        ×
      </button>
    </a>
  );
};

export default TelegramFloat;
